module.exports = __webpack_public_path__ + "static/media/Gratitude.43b57c6e.mp3";